export default __webpack_public_path__ + "static/media/SP-13.6751e56d.jpg";